<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择站点"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :handleSearchData="handleSearchData"
      :customShow="customShow"
      :isInput="isInput"
      :showName="customShowName || showName"
      :clearable="clearable"
      :fnRadioDisabled="fnRadioDisabled"
      :placeholder="placeholder"
      :querySearchAsync="querySearchAsync"
      valueKey="productName"
      :onSelect="onSelect"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section>{{scope.row[scope.column.property]}}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  siteDialogList,
} from 'api/service';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
    customShowName: {
      type: String,
      default: '',
    },
    fnRadioDisabled: {
      type: Function,
    },
    isInput: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
  },
  data () {
    return {
      showName: 'productName',
      // 存在两个服务商站点serviceUserId相同导致单选按钮同时选中，tableSelectTar: 'serviceUserId'改为'id'唯一标识
      tableSelectTar: 'id',
      defaultSearchData: {},
      searchBoxDataTmpl: {
        form: [
          { // 服务商名称
            label: '服务商名称',
            value: 'serviceName',
            type: 'input',
            placeholder: '请输入服务商名称',
          },
          { // 服务商账号
            label: '服务商账号',
            value: 'mobilePhone',
            type: 'input',
            placeholder: '请输入服务商账号',
          },
          { // 站点名称
            label: '站点名称',
            value: 'productName',
            type: 'input',
            placeholder: '请输入站点名称',
          },
          { // 服务电话
            label: '服务电话',
            value: 'serviceCall',
            type: 'input',
            placeholder: '请输入服务电话',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'customerCode',
          label: '司机姓名',
        },
        {
          prop: 'companyName',
          label: '司机手机',
        },
      ],
      tableTitle: [
        {
          prop: 'serviceName',
          label: '服务商名称',
        },
        {
          prop: 'mobilePhone',
          label: '服务商账号',
        },
        {
          prop: 'productName',
          label: '站点名称',
        },
        {
          prop: 'serviceCall',
          label: '服务商电话',
        },
        {
          prop: 'address',
          label: '服务地址',
        },
      ],
    };
  },
  methods: {
    getListApi: siteDialogList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    querySearchAsync (queryString, cb) {
      let resInfo = [];
      if (queryString && queryString.length) {
        siteDialogList({
          ...this.otherSearchData,
          page: 1,
          rows: 10,
          serviceName: '',
          mobilePhone: '',
          productName: queryString,
          serviceCall: '',
        }).then((res) => {
          console.log('res', res);
          if (res && res.items) {
            resInfo = res.items;
          }
          cb(resInfo);
        });
      } else {
        // 当没有输入的时候
        resInfo = this.defaultSearchData.items;
        cb(resInfo);
      }
    },
    async onSelect (item) {
      if (item) {
        this.$refs.chooseTmpl.chooseSelectItem(item);
      }
    },
    handleSearchData (searchBoxData) {
      return searchBoxData;
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>
</style>
